import React from 'react';
import { formatDateToMMDDYYYY } from '../../utils/dateUtils';
import {
  getRecDerivedDates,
  isoDateOnly,
} from '../../utils/recSchedulingDates';

interface RecOnboardingSummaryLinesProps {
  episodeStartDate: string | null | undefined;
  admissionDate: string | null | undefined;
  recertDate: string | null | undefined;
}

/**
 * The "what a REC push creates" lines — admission, previous episode [N-60,
 * N-1], upcoming episode [N, N+59], and the REC visit date — shared by the
 * Scheduling tab's summary box and the Push tab's pre-push alert so the two
 * renderings can never disagree. Callers own the wrapper styling and gate on
 * getRecDerivedDates themselves; renders null without an episode start.
 */
export const RecOnboardingSummaryLines: React.FC<
  RecOnboardingSummaryLinesProps
> = ({ episodeStartDate, admissionDate, recertDate }) => {
  const derived = getRecDerivedDates(episodeStartDate);
  if (!derived) return null;
  const admission = isoDateOnly(admissionDate);
  const visitDate = isoDateOnly(recertDate);

  return (
    <>
      {admission && (
        <div>
          Patient&apos;s admission/original SOC was on{' '}
          {formatDateToMMDDYYYY(admission)}
        </div>
      )}
      <div>
        Previous episode from{' '}
        {formatDateToMMDDYYYY(derived.previousEpisodeStart)} to{' '}
        {formatDateToMMDDYYYY(derived.previousEpisodeEnd)}
      </div>
      <div>
        Upcoming episode from{' '}
        {formatDateToMMDDYYYY(derived.upcomingEpisodeStart)} to{' '}
        {formatDateToMMDDYYYY(derived.upcomingEpisodeEnd)}
      </div>
      {visitDate && (
        <div>
          OASIS Recertification visit on {formatDateToMMDDYYYY(visitDate)}
        </div>
      )}
    </>
  );
};
